import { handleFreeReturn } from '@lambda/commons/helpers';
import settings from '@/settings';

/**
 * Catalogue copy (product descriptions, the category SEO blocks in
 * `settings/seo`) is authored once for every storefront with `{{country}}`,
 * `{{return}}` and `{{warranty}}` standing in for the per-store values. Whoever
 * renders that text has to substitute them, or the braces reach the page.
 */
const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

const TOKENS: Record<string, string> = {
  country: settings.country,
  return: String(freeReturnDays),
  warranty: String(settings.warranty_month),
};

// `{{ country }}` and `{{country}}` are both used in the wild.
const TOKEN_PATTERN = /\{\{ *(\w+) *\}\}/g;

/**
 * Replaces the store tokens in a piece of authored copy. An unrecognised token
 * is left alone rather than blanked — a visible `{{foo}}` is a bug report,
 * silently deleted copy is not.
 */
export const interpolateStoreTokens = (text: string): string => {
  if (!text) {
    return text;
  }

  return text.replace(TOKEN_PATTERN, (match, token: string) =>
    token in TOKENS ? TOKENS[token] : match,
  );
};
